import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Opera } from "../../types"
import OperaForm from "./OperaForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesOpera, validationSchemaOpera } from "./OperaCommon"
import { useMemo } from "react"

export default function OperaModal({
  title,
  opera,
  save,
  show,
  onClose,
}: {
  title: string
  opera?: Opera
  save: (values: Opera) => Promise<void>
  show: boolean
  onClose: () => void
}) {

  const initialValues = useMemo(() => initialValuesOpera(opera) as Opera, [opera])
  const validationSchema = useMemo(() => validationSchemaOpera(), [])

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                height: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <OperaForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
